//
// Copyright (c) 2024 Emplifi
//

define(["marionette", "./template/apiKeyListTemplate.html"], function (
  Marionette,
  ApiKeyListTemplate,
) {
  "use strict";

  const ApiKeyListView = {};

  ApiKeyListView.apiKeyListLayout = Marionette.Layout.extend({
    template: ApiKeyListTemplate,
    regions: {
      apiKeyList: "#apiKeyList",
    },
    triggers: {
      "click #addApiKey": "add:apiKey",
    },
  });

  return ApiKeyListView;
});
